'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Image = require('../../02.molecules/Image/Image.js');
var Swiper = require('../../02.molecules/Swiper/Swiper.js');
require('./_index.scss.js');

var _excluded = ["items", "children"];
var CLASSNAME = 'varta-swiper-images',
    cnSwiper = "".concat(CLASSNAME, "__swiper"),
    cnSlide = "".concat(CLASSNAME, "__slide"),
    cnImage = "".concat(CLASSNAME, "__image"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnButtonNext = "".concat(cnButton, "--next"),
    cnButtonPrev = "".concat(cnButton, "--prev"),
    cnPagination = "".concat(CLASSNAME, "__pagination"),
    cnBullet = "".concat(CLASSNAME, "__bullet"),
    cnBulletActive = "".concat(cnBullet, "--active");
/**
 * 
 */

var SwiperImages = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(SwiperImages, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(SwiperImages);

  function SwiperImages() {
    _rollupPluginBabelHelpers.classCallCheck(this, SwiperImages);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(SwiperImages, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          children = _this$props.children,
          props = _rollupPluginBabelHelpers.objectWithoutProperties(_this$props, _excluded);

      if ((items === null || items === void 0 ? void 0 : items.length) < 2) {
        var _items = _rollupPluginBabelHelpers.slicedToArray(items, 1),
            item = _items[0];

        return /*#__PURE__*/React__default.createElement("div", {
          className: CLASSNAME
        }, /*#__PURE__*/React__default.createElement("div", {
          className: cnSlide
        }, /*#__PURE__*/React__default.createElement(Image, item)));
      }

      if (!items && React__default.Children.count(children) < 2) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: CLASSNAME
        }, /*#__PURE__*/React__default.createElement("div", {
          className: cnSlide
        }, children));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME)
      }, /*#__PURE__*/React__default.createElement(Swiper, _rollupPluginBabelHelpers.extends({
        loop: true,
        className: cnSwiper,
        slidesPerView: "auto",
        slideClass: cnSlide,
        navigation: {
          nextEl: ".".concat(cnButtonNext),
          prevEl: ".".concat(cnButtonPrev)
        },
        renderPrevButton: function renderPrevButton() {
          return /*#__PURE__*/React__default.createElement("button", {
            className: classNames(cnButton, cnButtonPrev)
          }, /*#__PURE__*/React__default.createElement(Icon, {
            id: "caret-left-light",
            size: "sm"
          }));
        },
        renderNextButton: function renderNextButton() {
          return /*#__PURE__*/React__default.createElement("button", {
            className: classNames(cnButton, cnButtonNext)
          }, /*#__PURE__*/React__default.createElement(Icon, {
            id: "caret-right-light",
            size: "sm"
          }));
        },
        pagination: {
          el: ".".concat(cnPagination),
          clickable: true,
          bulletClass: cnBullet,
          bulletActiveClass: cnBulletActive
        }
      }, props), items ? items.map(function (item, i) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: cnSlide,
          key: i
        }, /*#__PURE__*/React__default.createElement(Image, _rollupPluginBabelHelpers.extends({}, item, {
          // TODO use swiper lazy loading
          lazy: false,
          className: cnImage
        })));
      }) : React__default.Children.map(children, function (child, i) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: cnSlide,
          key: i
        }, child);
      })));
    }
  }]);

  return SwiperImages;
}(React__default.Component);
SwiperImages.propTypes = {
  /** Child nodes */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /** Array of items */
  items: PropTypes.array
};

module.exports = SwiperImages;
